import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import isNumber from 'lodash/isNumber';
import { EarningsCalculator, parseFloatOrFallback } from '../../../EarningsCalculator';
import DollarPriceInput from '../../DollarPriceInput';
/** DollarPriceInput w/ built-in EarningsCalculator in the `details` */ export const PriceInputWithEarnings = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { value, productType, isResale, placeholder = 0 } = _param, remainingDollarPriceInputProps = _object_without_properties(_param, [
        "value",
        "productType",
        "isResale",
        "placeholder"
    ]);
    return /*#__PURE__*/ React.createElement(DollarPriceInput, _object_spread({
        ref: ref,
        value: value,
        details: /*#__PURE__*/ React.createElement(EarningsCalculator, {
            price: parseFloatOrFallback(value, isNumber(placeholder) ? placeholder : 0),
            productType: productType,
            isResale: isResale
        }),
        placeholder: placeholder
    }, remainingDollarPriceInputProps));
});
PriceInputWithEarnings.displayName = 'PriceInputWithEarnings';
export default PriceInputWithEarnings;

//# sourceMappingURL=PriceInputWithEarnings.js.map